<template>
  <el-container class="PersonnelVehicleInformation">
    <el-card class="tabs-card">
      <el-form
        :inline="true"
        ref="formRef"
        :model="tableParams"
        class="demo-form-inline"
      >
        <el-form-item label="">
          <el-input v-model="tableParams.name" placeholder="姓名" clearable>
          </el-input>
        </el-form-item>
        <el-form-item label="">
          <el-button @click="refreshTable" type="primary">查询</el-button>
        </el-form-item>
        <el-form-item label="力量类型" v-if="tableSelection.length > 0">
          <h-selectcode
            type="strengthType"
            v-model="strengthGroupId"
            placeholder="力量类型"
          ></h-selectcode>
        </el-form-item>
      </el-form>
      <div class="table-box">
        <h-table
          ref="tableRef"
          v-model:data="tableData"
          v-model:columns="columns"
          :method="queryUserList"
          :params="tableParams"
          @handleClick="handleClick"
          @select="hzTableSelect"
          style="height: 100%"
        >
          <!-- <template #operation="{}"> </template> -->
        </h-table>
      </div>
      <div class="bottomCenter">
        <h-button type="primary" @click="submitForm()">确定</h-button>
        <h-button @click="formVisible = false">取消</h-button>
      </div>
    </el-card>
  </el-container>
</template>
<script>
import {
  defineComponent,
  nextTick,
  reactive,
  toRefs,
  ref,
  watchEffect,
} from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import { queryOrganList } from "@/api/system";
import { queryUserList } from "@/api/realPopulation/realPopulation";
import { strengthsave } from "@/api/threeSolid/threeSolid.js";
import util from "@util/js";
import { deleteUser } from "@/api/user";

import _ from "lodash";
export default defineComponent({
  name: "PersonnelVehicleInformation",
  components: {},
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue", "submit"],
  setup(props, context) {
    const state = reactive({
      tableSelection: [],
      filterText: "",
      rootNodeKey: "",
      treeCard: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
      },
      dataSource: [],
      userFormData: {},
      tableParams: {
        xm: "",
        xb: "",
        zjhm: "",
        mz: "",
        sjh: "",
        dh: "",
        nl: "",
        name: "",
      },
      tableData: [],
      formStatus: 1, // 1 添加  2 编辑
      formVisible: false,
      columns: [
        { type: "selection" },
        {
          label: "姓名",
          prop: "name",
        },
        {
          label: "性别",
          prop: "sexDict",
        },
        {
          label: "证件类型",
          prop: "cardTypeDict",
        },
        {
          label: "证件号码",
          prop: "cardNumber",
          width: "240px",
        },
      ],
      strengthGroupId: "",
    });

    const refData = toRefs(state);
    const tableRef = ref(null);
    // 当前选中节点变化时触发的事件
    const currentChange = (item, nodes) => {
      state.currentNode = item;
      state.tableParams.deptId = item.deptId;
      state.userFormData.parentId = item.deptId;
      nextTick(() => {
        tableRef.value && tableRef.value.refresh();
      });
    };
    // 获取结构树
    const queryOrganTreAsync = async () => {
      const result = await queryOrganList();
      const options = { pid: "parentId", id: "deptId", rootPid: result.top };
      const treeData = util.arrayToTree(result.deptList, options);
      state.dataSource = treeData;
      if (treeData[0]) {
        currentChange(treeData[0]);
        nextTick(() => {
          state.rootNodeKey = state.currentNode.deptId;
          // treeRef.value.setCurrentKey(state.currentNode.deptId);
        });
      }
    };
    queryOrganTreAsync();
    // 点击查询按钮
    const refreshTable = () => {
      tableRef.value && tableRef.value.refresh();
    };
    // 表单提交
    const userSubmit = () => {
      tableRef.value && tableRef.value.refresh();
    };

    // 点击table操作按钮
    const handleClick = (operate, row) => {
      const { emitKey } = operate;
      if (emitKey === "del") {
        ElMessageBox.confirm("您确认要删除该用户吗？", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(
          () => {
            deleteUserAsync([row.userId]);
          },
          () => {}
        );
      }
    };
    // 当用户手动勾选数据行的 Checkbox 时触发的事件
    const hzTableSelect = (selection) => {
      state.tableSelection = selection;
    };
    const deleteUserAsync = async (ids) => {
      const res = await deleteUser(ids);
      if (res.code === 0) {
        refreshTable();
        ElMessage({
          type: "success",
          message: "删除成功",
        });
      }
    };
    const methods = {
      submitForm() {
        if (state.strengthGroupId == "") {
          ElMessage.warning("请选择力量类型");
          return;
        }
        state.tableSelection.forEach((item) => {
          item.strengthGroupId = state.strengthGroupId;
        });
        context.emit("submitList", state.tableSelection);
        state.formVisible = false;
        context.emit("update:modelValue", state.formVisible);
      },
      // 选择然后选择对应的弹框
      selectChange(val) {
        // 1选择实有人 2新建居住人
        if (val === "1") {
        } else {
        }
        console.log(val, tableRef.value.tableData);
      },
    };
    watchEffect(() => {
      userSubmit();
      state.formVisible = props.modelValue;
    });
    watchEffect(() => {
      context.emit("update:modelValue", state.formVisible);
    });
    return {
      ...methods,
      ...refData,
      currentChange,
      refreshTable,
      hzTableSelect,
      handleClick,
      queryUserList,
      userSubmit,
      tableRef,
    };
  },
});
</script>
<style lang="scss" scoped>
.PersonnelVehicleInformation {
  height: 60vh;
  .tree-card {
    height: 100%;
    width: 300px;
    .input-with-select {
      margin-bottom: 10px;
    }
    .tree-box {
      flex: 1;
      overflow: auto;
      position: relative;
      .tree-header {
        position: sticky;
        top: 0;
        z-index: 2;
        padding: 10px 0;
        background-color: var(--el-color-white);
        color: var(--el-text-color-regular);
        @include flex-row-sb-c;
        .tree-name {
          flex: 1;
          margin-right: 10px;
          padding-left: 48px;
        }
        .tree-status {
          width: 50px;
        }
      }
    }
  }
  .tabs-card {
    flex: 1;
    margin-left: 10px;
    .tabs-tabel-box {
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }
    .table-box {
      // flex: 1;
      height: 100%;
      overflow: hidden;

      .table-role {
        background-color: var(--el-color-info-lighter);
        box-sizing: border-box;
        border-color: transparent;
        border-radius: 5px;
        margin: 2px 0 2px 6px;
        text-align: center;
      }
    }
  }
  .bottomCenter {
    display: flex;
    justify-content: center;
    border-top: 1px solid;
    border-color: #eee;
    padding-top: 16px;
  }
}
#hz-table {
  height: 100% !important;
}
</style>
